<template>
  <div class="text-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="链接地址" name="2">
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <linkSet
            :linkAddress.sync="linkAddress"
            :internalLinkName.sync="internalLinkName"
            :subLinkName.sync="subLinkName"
            :linkUrl.sync="linkUrl"
            :accessRulers.sync="accessRulers"
            :openBlankPage.sync="openBlankPage"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="text"
      :options="options"
      type="Data"
      :rect_id="rect_id"
      :container_id="container_id"
    />
  </div>
</template>

<script>
export default {
  name: "text-options-data",
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1"],
      collapseActiveNames: []
    }
  },
  computed: {
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    openBlankPage: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openBlankPage", "openBlankPage", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBlankPage", false)
      }
    },
    internalLinkName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "internalLinkName", "internalLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "internalLinkName", false)
      }
    },
    subLinkName: {
      get(val) {
        return this.checkAndSetPrimaryVal(this.options, "subLinkName", "subLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "subLinkName", false)
      }
    },
    linkAddress: {
      get() {
        return this.options.linkAddress || ""
      },
      set(val) {
        this.$changeOptionsEV(val, "linkAddress", false)
      }
    },
    linkUrl: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "linkUrl", "linkUrl", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrl", false)
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
      if (val === "3" && this.currentFieldMappingList.length === 0 && this.noCacheComponent) {
        this.getBaseModuleDataLoop(true)
      }
    }
  }
}
</script>

<style scoped>
.left-label {
  min-width: 60px;
}
.card {
  background: rgba(41, 44, 49, 1);
}
.count-limit-item/deep/ .el-input__inner {
  background: #35383f;
  padding: 0 12px;
  border-radius: 4px;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item /deep/ .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item /deep/ .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item /deep/ .el-radio-group {
  width: 80px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataType-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.dataUrl-item .tips {
  color: var(--thirdTextColor);
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px 4px 4px 12px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
.mt4 {
  margin-top: 4px;
}
</style>
